export default {
  'formandstep-form.basic.title': 'Basic form',
  'formandstep-form.basic.description':
    'Form pages are used to collect or verify information to users, and basic forms are common in scenarios where there are fewer data items.',

  'formandstep-form.email.required': 'Por favor insira seu email!',
  'formandstep-form.email.wrong-format': 'O email está errado!',
  'formandstep-form.userName.required': 'Por favor insira nome de usuário!',
  'formandstep-form.password.required': 'Por favor insira sua senha!',
  'formandstep-form.password.twice': 'As senhas não estão iguais!',
  'formandstep-form.strength.msg':
    'Por favor insira pelo menos 6 caracteres e não use senhas fáceis de adivinhar.',
  'formandstep-form.strength.strong': 'Força: forte',
  'formandstep-form.strength.medium': 'Força: média',
  'formandstep-form.strength.short': 'Força: curta',
  'formandstep-form.confirm-password.required': 'Por favor confirme sua senha!',
  'formandstep-form.phone-number.required': 'Por favor insira seu telefone!',
  'formandstep-form.phone-number.wrong-format': 'Formato de telefone errado!',
  'formandstep-form.verification-code.required': 'Por favor insira seu código de verificação!',

  'formandstep-form.form.get-captcha': 'Get Captcha',
  'formandstep-form.captcha.second': 'sec',
  'formandstep-form.email.placeholder': 'Email',
  'formandstep-form.password.placeholder': 'Senha',
  'formandstep-form.confirm-password.placeholder': 'Confirme a senha',
  'formandstep-form.phone-number.placeholder': 'Telefone',
  'formandstep-form.verification-code.placeholder': 'Código de verificação',
  'formandstep-form.form.optional': ' (optional) ',
  'formandstep-form.form.submit': 'Submit',
  'formandstep-form.form.save': 'Save',
  'formandstep-form.title.label': 'Title',
  'formandstep-form.title.placeholder': 'Give the target a name',
  'formandstep-form.date.label': 'Start and end date',
  'formandstep-form.placeholder.start': 'Start date',
  'formandstep-form.placeholder.end': 'End date',
  'formandstep-form.goal.label': 'Goal description',
  'formandstep-form.goal.placeholder': 'Please enter your work goals',
  'formandstep-form.standard.label': 'Metrics',
  'formandstep-form.standard.placeholder': 'Please enter a metric',
  'formandstep-form.client.label': 'Client',
  'formandstep-form.label.tooltip': 'Target service object',
  'formandstep-form.client.placeholder':
    'Please describe your customer service, internal customers directly @ Name / job number',
  'formandstep-form.invites.label': 'Inviting critics',
  'formandstep-form.invites.placeholder':
    'Please direct @ Name / job number, you can invite up to 5 people',
  'formandstep-form.weight.label': 'Weight',
  'formandstep-form.weight.placeholder': 'Please enter weight',
  'formandstep-form.public.label': 'Target disclosure',
  'formandstep-form.label.help': 'Customers and invitees are shared by default',
  'formandstep-form.radio.public': 'Public',
  'formandstep-form.radio.partially-public': 'Partially public',
  'formandstep-form.radio.private': 'Private',
  'formandstep-form.publicUsers.placeholder': 'Open to',
  'formandstep-form.option.A': 'Colleague A',
  'formandstep-form.option.B': 'Colleague B',
  'formandstep-form.option.C': 'Colleague C',
};
